import { useUserRepository } from '@ayocore/platform/identity/client/rpc';
import { createRepositoryFilter } from '@ayocore/platform/client/components/RepositoryTable/createRepositoryFilter';
import type { LeadRepository } from '@ayocore/erp/crm/server/repositories/LeadRepository';

type UserRepo = ReturnType<typeof useUserRepository>;

/**
 * Фильтр лидов по менеджеру (single).
 * Список включает и уволенных/деактивированных менеджеров (onlyHuman, без фильтра
 * по is_active) — нужны для отчётов по лидам бывших сотрудников. Активные менеджеры
 * идут первыми (orderBy 'is_active' desc), внутри группы — по алфавиту (orderByName).
 * Опция «Без менеджера» (XOR) фильтрует лиды с пустым manager_id.
 */
export const FilterByManager = createRepositoryFilter<LeadRepository, UserRepo>({
  name: 'manager',
  placeholder: 'Выберите менеджера...',
  width: 180,
  source: () => useUserRepository().onlyHuman().orderBy('is_active', 'desc').orderByName('asc'),
  displayField: 'name',
  by: (repo, id) => repo.filterByManager(id),
  without: { label: 'Без менеджера', apply: repo => repo.filterWithoutManager() },
});
